const MODAL_TYPE = {
  DESCRIBE: "describe",
  PROJECT_COMPLETE: "project-complete",
  CONFIRM: "confirm",
  CONFIRM_STUDY: "confirm-study",
  TOPUP: "topup",
};

export { MODAL_TYPE };
